// @ts-nocheck
import * as React from "react";

const ThreadRollingDieChanges: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            width="164.000000pt"
            height="186.000000pt"
            viewBox="0 0 164.000000 186.000000"
            preserveAspectRatio="xMidYMid meet"
        >
            <g transform="translate(0.000000,186.000000) scale(0.100000,-0.100000)" fill="#000000" stroke="none">
                <path d="M317 1563 c-4 -3 -7 -291 -7 -640 l0 -633 500 0 500 0 2 495 3 495 -145 145 -145 145 -351 0 c-193 0 -354 -3 -357 -7z m685 -170 l3 -138 138 -3 137 -3 -2 -462 -3 -462 -462 -3 -463 -2 0 605 0 605 325 0 324 0 3 -137z m238 -95 c0 -5 -45 -8 -100 -8 l-100 0 0 107 0 106 100 -99 c55 -54 100 -102 100 -106z" />
                <path d="M593 1184 l-52 -65 -16 25 c-18 27 -39 34 -50 16 -8 -13 52 -90 68 -89 16 0 138 159 131 170 -12 20 -31 6 -81 -57z" />
                <path d="M784 1119 c-14 -24 18 -29 152 -27 123 3 139 5 142 21 3 16 -9 17 -142 17 -93 0 -147 -4 -152 -11z" />
                <path d="M595 885 c-27 -36 -53 -65 -56 -65 -3 0 -12 11 -19 25 -14 26 -34 33 -45 15 -8 -14 54 -92 70 -88 19 5 137 157 130 168 -13 21 -32 7 -80 -55z" />
                <path d="M784 829 c-14 -24 18 -29 152 -27 123 3 139 5 142 21 3 16 -9 17 -142 17 -93 0 -147 -4 -152 -11z" />
                <path d="M616 608 c-19 -24 -44 -54 -54 -68 l-19 -24 -26 29 c-20 24 -28 27 -38 18 -9 -10 -6 -20 16 -48 38 -50 55 -55 79 -20 12 15 40 52 64 82 39 48 46 73 22 73 -5 0 -25 -19 -44 -42z" />
                <path d="M785 540 c-15 -24 13 -30 151 -30 137 0 144 1 144 20 0 19 -7 20 -144 20 -86 0 -147 -4 -151 -10z" />
            </g>
        </svg>
    );
};

export default React.memo(ThreadRollingDieChanges);
